import { Box, Card, CardContent, Grid, Link, SvgIcon, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useTranslation } from 'next-i18next';
import type { AppointmentInformation } from '../AppointmentReview';
import iconMap from '@src/icons';
import { useFormSectionStore } from '@src/store';
export default function AppointmentCard({
  title,
  content,
  icon,
  editSectionIndex
}: Readonly<AppointmentInformation>) {
  const Icon = iconMap[icon] ?? iconMap.SentimentVeryBad ?? (() => null);
  const {
    setActiveSection
  } = useFormSectionStore(store => store);
  const {
    t
  } = useTranslation('appointmentReview');
  return <Card elevation={0} variant="outlined" sx={{
    height: '100%'
  }} className="appointment-card" data-sentry-element="Card" data-sentry-component="AppointmentCard" data-sentry-source-file="AppointmentCard.tsx">
			<CardContent sx={{
      height: '100%'
    }} data-sentry-element="CardContent" data-sentry-source-file="AppointmentCard.tsx">
				<Grid container sx={{
        height: '100%'
      }} data-sentry-element="Grid" data-sentry-source-file="AppointmentCard.tsx">
					<Grid xs={11} item data-sentry-element="Grid" data-sentry-source-file="AppointmentCard.tsx">
						<Typography variant="header4" color="text.primary" data-sentry-element="Typography" data-sentry-source-file="AppointmentCard.tsx">
							{title}
						</Typography>
						<Grid container direction="column" mt={2} data-sentry-element="Grid" data-sentry-source-file="AppointmentCard.tsx">
							{content.map((text, index) => <Typography key={index} variant={index === 0 || index === 3 ? 'bodyLargeBook' : 'bodyMediumBook'} color="text.secondary" data-private>
									{text}
								</Typography>)}
						</Grid>
					</Grid>
					<Grid item xs={1} data-sentry-element="Grid" data-sentry-source-file="AppointmentCard.tsx">
						<Grid container direction="column" alignItems="center" sx={{
            height: '100%'
          }} data-sentry-element="Grid" data-sentry-source-file="AppointmentCard.tsx">
							<Box sx={{
              marginBottom: 'auto',
              height: '2rem',
              alignItems: 'center',
              display: 'flex'
            }} data-sentry-element="Box" data-sentry-source-file="AppointmentCard.tsx">
								{typeof editSectionIndex === 'number' && editSectionIndex >= 0 ? <Link component="button" type="button" color="secondary.main" underline="none" variant="bodyMediumSemiBold" sx={{
                cursor: 'pointer'
              }} onClick={() => setActiveSection(editSectionIndex)}>
										{t('editCard')} <Box sx={visuallyHidden}>{title}</Box>
									</Link> : null}
							</Box>
							<SvgIcon viewBox="0 0 32 32" sx={{
              height: 32,
              width: 32
            }} data-test-id="icon_card_appointment" data-sentry-element="SvgIcon" data-sentry-source-file="AppointmentCard.tsx">
								<Icon data-sentry-element="Icon" data-sentry-source-file="AppointmentCard.tsx" />
							</SvgIcon>
						</Grid>
					</Grid>
				</Grid>
			</CardContent>
		</Card>;
}